<template>
    <section class="project-step mgt-3 mgb-3">
        <div class="custom-container">
            <form id="form-step-2" class="step-form general-form">
                <input type="hidden" name="project" :value="project.id"/>
                <div class="row project-heading-row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="return-btn-container">
                            <a :href="getBackLink()">
                                <i class="fad fa-long-arrow-alt-left"></i>
                                <span> Inapoi </span>
                            </a>
                        </div>
                        <div class="section-heading">
                            <i class="fad fa-layer-plus"></i>
                            <h1 class="m-color">
                                Modifica Model
                            </h1>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="mt-3 mb-5 col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="secondary-heading">
                            <div class="secondary-heading-icon">
                                <i class="fad fa-layer-group"></i>
                            </div>
                            <span> * Definire Model </span>
                        </div>
                        <div class="row">
                            <input type="hidden" name="type" :value="model.type">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                                <div class="row">
                                    <div class="col-lg-8 col-xl-8 col-md-12 col-12">
                                        <div class="input-container">
                                            <div class="flex-row align-items-end input-group mg-b">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon1">Tip</span>
                                                </div>
                                                <input type="text" id="model_type" name="model_type"
                                                       v-model="model.model_type" placeholder="Tip model">
                                                <label class="custom-label custom-label-active" for="model_type">
                                                    Tip model </label>
                                            </div>
                                            <p class="custom-input-error" id="model_type_error"></p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-md-12 col-12">
                                        <div class="input-container" v-if="model.type != 'commercial'">
                                            <div class="input-group mg-b">
                                                <select name="rooms_count" id="rooms_count"
                                                        v-model="model.rooms_count_id">
                                                    <option selected="selected" disabled="disabled" value=""> * Nr.
                                                        Camere
                                                    </option>
                                                    <option v-for="room in roomsCount" :value="room.id"
                                                            :key="room.id"> {{room.name}}
                                                    </option>
                                                </select>
                                                <div class="input-icon">
                                                    <i class="fad fa-sort-numeric-up-alt"></i>
                                                </div>
                                                <label class="custom-label custom-label-active" for="rooms_count"> *
                                                    Nr. Camere </label>
                                            </div>
                                            <p class="custom-input-error" id="rooms_count_error"></p>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-xl-12 col-md-12 col-12">
                                        <div class="editor-wrapper">
                                            <vue-editor
                                                v-model="description"
                                                :editorOptions="{
                                                    modules: {
                                                        toolbar: [
                                                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                                            ['bold', 'italic', 'underline', 'strike'],
                                                            [{ 'align': ''}, {'align': 'center'}, { 'align': 'right'}, {'align': 'justify'}],
                                                            [{ 'list': 'bullet' }, { 'list': 'ordered'}, { 'indent': '-1'}, { 'indent': '+1' }],
                                                            ['clean'],
                                                            [{ 'color': [] }, { 'background': [] }],
                                                            ['link', 'image', 'video', 'emoji'],
                                                        ],
                                                        'emoji-toolbar': true,
                                                        // 'emoji-textarea': true,
                                                        'emoji-shortname': true,
                                                    }
                                                }"/>
                                            <p class="custom-input-error" id="description_error"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="mt-3 mb-5 col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="secondary-heading">
                            <div class="secondary-heading-icon">
                                <i class="fad fa-ruler-triangle"></i>
                            </div>
                            <span> Suprafata </span>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-xl-4 col-md-12 col-12">
                                <div class="input-container">
                                    <div class="input-group mg-b">
                                        <input type="number" id="useful-surface" name="useful_surface"
                                               v-model="model.useful_surface" placeholder="* Suprafata Totala (m²)">
                                        <div class="input-icon">
                                            <i class="fad fa-window-frame-open"></i>
                                        </div>
                                        <label class="custom-label custom-label-active" for="useful-surface"> *
                                            Suprafata Totala(m²) </label>
                                    </div>
                                    <p class="custom-input-error" id="useful_surface_error"></p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-md-12 col-12">
                                <div class="input-container">
                                    <div class="input-group mg-b">
                                        <input type="number" id="terrace-surface" name="terrace_surface"
                                               v-model="model.terrace_surface" placeholder="Suprafata Balcon">
                                        <div class="input-icon">
                                            <i class="fad fa-window-frame-open"></i>
                                        </div>
                                        <label class="custom-label custom-label-active" for="terrace-surface">
                                            Suprafata Balcon(m²) </label>
                                    </div>
                                    <p class="custom-input-error" id="terrace_surface_error"></p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-md-12 col-12" v-if="modelCategory === 'house'">
                                <div class="input-container">
                                    <div class="input-group mg-b">
                                        <input type="number" id="garden-garden_surface" name="garden_surface"
                                               v-model="model.garden_surface" placeholder="Suprafata teren">
                                        <div class="input-icon">
                                            <i class="fad fa-flower-daffodil"></i>
                                        </div>
                                        <label class="custom-label custom-label-active" for="garden-garden_surface"> Suprafata teren(m²) </label>
                                    </div>
                                    <p class="custom-input-error" id="garden_surface_error"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="mt-2 mb-4 col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="secondary-heading">
                            <div class="secondary-heading-icon">
                                <i class="fad fa-tag"></i>
                            </div>
                            <span> Pret </span>
                        </div>
                        <div class="project-images-wrapper">
                            <div class="row">
                                <div class="col-xl-4 col-lg-4 col-md-12 col-12">
                                    <div class="input-container">
                                        <div class="input-group mg-b">
                                            <input type="number" id="model_price" name="price" v-model="model.price"
                                                   placeholder="* Pret Model">
                                            <div class="input-icon">
                                                <i class="fad fa-euro-sign"></i>
                                            </div>
                                            <label class="custom-label custom-label-active" for="model_price"> *
                                                Pret Model </label>
                                        </div>
                                        <p class="custom-input-error" id="price_error"></p>
                                    </div>
                                </div>
                                <div class="col-lg-8 col-xl-8 col-md-12 col-12">
                                    <div class="price-addition-type row-flex">
                                        <label class="box-radio-card">
                                            <input type="radio" name="price_with_vat" class="card-input-element" value="0"
                                                   v-model="model.price_with_vat"/>
                                            <div class="panel panel-default card-input">
                                                <i class="fad fa-euro-sign"></i>
                                                <h2 class="pannel-heading"> +TVA </h2>
                                            </div>
                                        </label>
                                        <label class="box-radio-card">
                                            <input type="radio" name="price_with_vat" class="card-input-element" value="1"
                                                   v-model="model.price_with_vat"/>
                                            <div class="panel panel-default card-input">
                                                <i class="fad fa-euro-sign"></i>
                                                <h2 class="pannel-heading"> TVA Inclus </h2>
                                            </div>
                                        </label>
                                        <p class="custom-input-error" id="price_with_vat_error"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-4 col-lg-4 col-md-12 col-12">
                                    <div class="input-container">
                                        <div class="input-group mg-b">
                                            <input type="number" id="model_credit_price" name="credit_price" v-model="model.credit_price"
                                                   placeholder="Pret (cu credit)">
                                            <div class="input-icon">
                                                <i class="fad fa-euro-sign"></i>
                                            </div>
                                            <label class="custom-label custom-label-active" for="model_credit_price">
                                              Pret (cu credit) </label>
                                        </div>
                                        <p class="custom-input-error" id="credit_price_error"></p>
                                    </div>
                                </div>
                                <div class="col-lg-8 col-xl-8 col-md-12 col-12">
                                    <div class="price-addition-type row-flex">
                                        <label class="box-radio-card">
                                            <input type="radio" name="credit_price_with_vat" class="card-input-element" value="0"
                                                   v-model="model.credit_price_with_vat"/>
                                            <div class="panel panel-default card-input">
                                                <i class="fad fa-euro-sign"></i>
                                                <h2 class="pannel-heading"> +TVA </h2>
                                            </div>
                                        </label>
                                        <label class="box-radio-card">
                                            <input type="radio" name="credit_price_with_vat" class="card-input-element" value="1"
                                                   v-model="model.credit_price_with_vat"/>
                                            <div class="panel panel-default card-input">
                                                <i class="fad fa-euro-sign"></i>
                                                <h2 class="pannel-heading"> TVA Inclus </h2>
                                            </div>
                                        </label>
                                        <p class="custom-input-error" id="credit_price_with_vat_error"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                                    <div class="general-check step-check">
                                        <input type="checkbox" name="show_payment_methods" value="1"
                                               id="payment_type_show" class="custom-checkbox"
                                               v-model="model.show_payment_methods">
                                        <label for="payment_type_show" class="custom-checkbox-label">
                                            <span></span>
                                            <p>
                                                Afiseaza modalitatea de plata
                                            </p>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="mt-3 mb-5 col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="secondary-heading">
                            <div class="secondary-heading-icon">
                                <i class="fad fa-images"></i>
                            </div>
                            <span> Imagini Model </span>
                        </div>

                        <div class="project-images-wrapper">
                            <p class="custom-input-error" :id="`ungroupedImages-${index}_error`"
                               v-for="(img, index) in ungroupedImages" :key="`ung-${index}`"></p>
                            <div class="row">
                                <div class="col-12">
                                    <div class="images-group-uploader">
                                        <input type="file" name="groupImages" id="groupImages" multiple
                                               @change="onMultipleFileChange">
                                        <label for="groupImages" class="general-btn positive-btn">
                                            <span> Incarca imagini </span>
                                            <i class="fad fa-upload"></i>
                                        </label>
                                    </div>
                                    <draggable :forceFallback="true" v-if="ungroupedImages" class="images-group card-columns model"
                                               :list="ungroupedImages" group="picsGroup" @change="onDragElementEnd">
                                        <div v-for="(image, index, key) in ungroupedImages" :key="key"
                                             class="group-uploaded-img card">
                                            <img :src="image.base64" @click="triggerImg"/>
                                            <div class="clear-post-img" @click="removeUngroupImage(index, image)">
                                                <i class="fad fa-trash-alt"></i>
                                            </div>
                                        </div>
                                    </draggable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="secondary-heading">
                            <div class="secondary-heading-icon">
                                <i class="fad fa-video"></i>
                            </div>
                            <span> Link Video Model (doar linkuri Youtube) </span>
                        </div>
                        <div class="video-links-wrapper">
                            <div class="row">
                                <div class="mb-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12" v-for="(videoRow, index) in videoRows" :key="index">
                                    <div class="input-container">
                                        <div class="input-group mg-b">
                                            <input v-model="videoRow.url" placeholder="Link Video" type="text"
                                                   name="video[]">
                                            <div class="input-icon">
                                                <i class="fad fa-video"></i>
                                            </div>
                                            <label class="custom-label"> Link Video </label>
                                        </div>
                                        <span class="floating-remove-el" @click="removeModelVideoElement(index)">
                                            <i class="fad fa-times-circle"></i>
                                        </span>
                                        <p class="custom-input-error" :id="`video-${index}_error`"></p>
                                    </div>
                                    <linkPrevue :url="videoRow.url">
                                        <template slot-scope="props">
                                            <div class="prevue-card">
                                                <a v-bind:href="props.url" target="_blank"
                                                   class="general-btn positive-btn prevue-viewmore-btn">
                                                    <span> Vezi link </span>
                                                    <i class="fad fa-eye"></i>
                                                </a>
                                            </div>
                                        </template>
                                    </linkPrevue>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div class="mt-3 center-content save-btn">
                                        <p class="general-btn positive-btn" @click="addModelVideoRow()">
                                            <i class="fad fa-video-plus"></i>
                                            <span> Adauga link </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-heading-row" style="position: relative;">
                    <div class="mt-3 mb-5 col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="general-check step-check">
                            <input type="checkbox" name="publish_model" id="publish_model" class="custom-checkbox"
                                   v-model="model.publish">
                            <label for="publish_model" class="custom-checkbox-label">
                                <span></span>
                                <p>
                                    Publica modelul in platforma
                                    <span class="item-action-btn"
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          title="Pentru a fi publicat trebuie sa fie adaugata cel putin o oferta valabila sau vanduta in disponibilitati.">
                                        <i class="fad fa-info-circle"></i>
                                    </span>
                                </p>
                                <p style="color:red;">&nbsp;Pentru a fi publicat trebuie sa fie adaugata cel putin o oferta vanduta sau disponibila la disponibilitati.</p>
                            </label>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="mt-3 center-content save-btn">
                            <button type="submit" class="general-btn positive-btn">
                                <i class="fad fa-save"></i>
                                <span> Salveaza </span>
                            </button>
                            <button type="button" class="general-btn positive-btn" @click="save(true)">
                                <span> Salveaza si modifica disponibilitati </span>
                                <i class="fad fa-long-arrow-alt-right"></i>
                            </button>
                        </div>
                    </div>
                    <div class="section-loading-screen" v-if="showLoading">
                        <div class="section-loading-bubbles">
                            <span class="d1"></span>
                            <span class="d2"></span>
                            <span class="d3"></span>
                            <span class="d4"></span>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div id="fullscreen-preview" class="fullscreen-img" :class="{'fullscreen-img-active' : fullScreen}">
            <!-- :style="{backgroundImage: `url(${src})`}" -->
            <div class="fullscreen-container" v-if="fullScreenScr">
                <img :src="fullScreenScr" alt="">
            </div>
            <div class="close-element" @click="fullScreen = !fullScreen">
                <i class="fad fa-times-circle"></i>
            </div>
        </div>
    </section>
</template>

<script>
  import draggable from 'vuedraggable'
  import linkPrevue from 'link-prevue'
  import { VueEditor, Quill } from "vue2-editor";
  import Emoji from "quill-emoji/dist/quill-emoji";

  Quill.register("modules/emoji", Emoji);

  export default {
    name: "EditModel",
    props: ['project', 'model', 'images', 'roomsCount'],
    components: {
      draggable,
      linkPrevue,
      VueEditor
    },
    data() {
      return {
        editor: null,
        showLoading: false,
        description: '',
        ungroupedImages: [],
        modelVideoRows: [],
        files: [],
        videoRows: [],
        modelCategory: '',
        fullScreenScr: '',
        fullScreen: false,
        deleteImages: []
      }
    },
    mounted() {
      let vm = this;
      $('#form-step-2').submit(function (e) {
        e.preventDefault();
        vm.save(false);
      })

      this.ungroupedImages = (this.images[0]) ? this.images[0] : []
      let videos = this.model.videos;
      if (videos && videos.length > 0) {
        videos.forEach(function (video) {
          vm.videoRows.push({url: video.link});
        });
      } else {
        vm.videoRows.push({url: ''});
      }

      this.description = this.model.description;
    },
    methods: {
      addModelVideoRow: function () {
        this.videoRows.push({
          url: ''
        });
      },
      removeModelVideoElement: function (index) {
        if ((index < 1) && (this.videoRows.length < 2)) {
            this.videoRows[0].url = '';
            return;
        }
        this.videoRows.splice(index, 1);
      },
      onDragElementEnd: function (event) {
        if (event.removed) {
          if (event.removed.element.id && event.removed.element.id > 0) {
            this.deleteImages.push(_.clone(event.removed.element.id))
            event.removed.element.id = null
          }
        }
      },
      handleClone(item) {
        // Create a fresh copy of item
        let cloneMe = JSON.parse(JSON.stringify(item));
        this.$delete(cloneMe, 'uid');
        return cloneMe;
      },
      onFileChange(e) {
        const file = e.target.files[0];
        this.url = URL.createObjectURL(file);
        this.image = this.$refs.image.files[0];
      },
      clearPostImage() {
        this.url = null;
        this.image = '';
      },

      onMultipleFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
          return;
        this.createImage(files);
      },
      createImage(files) {
        let vm = this;
        for (let index = 0; index < files.length; index++) {
          let reader = new FileReader();
          reader.onload = function (event) {
            const groupImageUrl = {base64: event.target.result};
            vm.ungroupedImages.push(groupImageUrl);
          }
          reader.readAsDataURL(files[index]);
        }
      },
      removeUngroupImage(index, image) {
        if (image.id && image.id > 0) {
          this.deleteImages.push(image.id)
        }
        this.ungroupedImages.splice(index, 1)
      },
      triggerImg: function (img) {
        this.fullScreenScr = img.srcElement.src;
        this.fullScreen = !this.fullScreen
      },
      save(redirectNextStep) {
        window.resetErrors()
        let vm = this;
        vm.showLoading = true;
        let myForm = document.getElementById('form-step-2');
        let formData = new FormData(myForm);

        // send only new images
        let sendImages = [];
        this.ungroupedImages.forEach(function(image) {
          let imageClone = JSON.parse(JSON.stringify(image));
          if (imageClone.id && imageClone.id > 0) {
            delete imageClone.base64;
          }
          sendImages.push(imageClone);
        })
        formData.append('ungroupedImages', JSON.stringify(sendImages));
        formData.append('deleteImages', JSON.stringify(this.deleteImages));
        if(this.description != null) {
          formData.append('description', this.description);
        }
        window.axios.post(`/developer/${this.project.id}/model/${this.model.id}/edit`, formData)
          .then(function () {
            vm.showLoading = false;
            window.Swal.fire({
              html: 'Modelul a fost editat cu succes',
              icon: 'success',
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false
            }).then(() => {
              if(redirectNextStep) {
                if(vm.model.type === 'house') {
                  window.openEditHouseItemsModal(vm.model.id)
                } else {
                  window.openEditModelItemsModal(vm.model.id)
                }

              } else {
                if (vm.model.type === 'commercial') {
                  window.location.href = `/developer/project/${vm.model.project_id}?tab=space`
                } else if (vm.model.type === 'house') {
                  window.location.href = `/developer/project/${vm.model.project_id}?tab=house`
                } else {
                  window.location.href = `/developer/project/${vm.model.project_id}?tab=apartment`
                }
              }
            })
          })
          .catch(function (err) {
            vm.showLoading = false;
            vm.buttonDisable = false;
            window.showError(err)
          });
      }
    }
  }
</script>

<style>
/* This selector is available globally */
.ck-content {
    height: 150px;
    overflow-y: auto;
}
</style>